import {gsap, SplitText} from "../LibrariesImport";

export default class TextAppear {
	static init() {
		const items = document.querySelectorAll(
			".title-banner,.title-banner-home, .title-level-1, .title-level-2, .title-level-3"
		);

		document.fonts.ready.then(() => {
			items.forEach(item => {
				if (item.classList.contains("no-text-appear")) {
					return;
				}
				if (item.classList.contains("arrow-title")) {
					return;
				}
				if (item.classList.contains("arrow-title-alt")) {
					return;
				}
				gsap.set(item, {opacity: 1});
				const delay = item.dataset.textAppearDelay ?? 0;

				SplitText.create(item, {
					type: "lines",
					lineClass: "line",
					autoSplit: true,
					// mask: "lines",
					onSplit: (self) => {
						return gsap.from(self.lines, {
							delay: delay,
							duration: 1.5,
							yPercent: 50,
							opacity: 0,
							stagger: 0.15,
							ease: "expo.out",
							scrollTrigger: {
								trigger: item,
								start: "top 90%",
							}
						});
					}
				});
			});

			document.querySelectorAll(".title-key-number").forEach(item => {
				gsap.set(item, {opacity: 1});
				const delay = item.dataset.textAppearDelay ?? 0;

				SplitText.create(item, {
					type: "chars",
					charClass: "char",
					autoSplit: true,
					// mask: "lines",
					onSplit: (self) => {
						return gsap.from(self.chars, {
							delay: delay,
							duration: 2,
							yPercent: 50,
							opacity: 0,
							stagger: 0.2,
							ease: "expo.out",
							scrollTrigger: {
								trigger: item,
								start: "top 90%",
							}
						});
					}
				});
			});
		});
	}
}
